import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Link, useLocation } from 'react-router-dom'

import { getAvatar } from '../../helpers/consultdex-wp-api'
import { useUser } from '../../contexts'

import { AvatarMenu } from '../specialized-components'


const isActive = (path, route) => path === route || path.startsWith(route)


export const TopBar = ({ menuEntries = [], avatarMenuEntries }) => {
  const { userAvatar, setUserAvatar, role, logoutUser } = useUser()
  const path = useLocation().pathname


  useEffect(() => {
    if (userAvatar === undefined) {
      getAvatar()
        .then(avatar => {
          setUserAvatar(avatar)
        })
        .catch(() => {
          setUserAvatar(null)
        })
    }
  }, [setUserAvatar, userAvatar])


  const avatarMenuEntriesNode = avatarMenuEntries.map((entry, index) => (
    <li key={index}>
      <Link to={entry.route} className="dropdown-item">
        {entry.label}
      </Link>
    </li>
  ))


  return (
    <header className="dashboard-topbar">
      <div className="dashboard-topbar-inner">
        <Link to="/" className="dashboard-brand" aria-label="ConsultDex dashboard">
          <img src={`${process.env.PUBLIC_URL}/brand/consultdex-icon.png`} alt="" width="32" height="32" />
          <img
            src={`${process.env.PUBLIC_URL}/brand/consultdex-white.png`}
            alt="ConsultDex"
            className="dashboard-wordmark"
            width="150"
            height="45"
          />
        </Link>

        <nav className="dashboard-tabs" aria-label="Dashboard">
          {menuEntries.map(entry => (
            <Link
              to={entry.route}
              key={entry.route}
              className={`dashboard-tab${isActive(path, entry.route) ? ' is-active' : ''}`}
              aria-current={isActive(path, entry.route) ? 'page' : undefined}
            >
              {entry.label}
            </Link>
          ))}
        </nav>

        <AvatarMenu
          avatarProps={userAvatar}
          role={role}
          menuEntries={avatarMenuEntriesNode}
          handleLogout={logoutUser}
        />
      </div>
    </header>
  )
}


TopBar.propTypes = {
  menuEntries: PropTypes.array,
  avatarMenuEntries: PropTypes.array.isRequired
}
